import { computed, makeObservable } from 'mobx';
import { AppController } from 'app/controllers';
import { AppViewModel } from '..';

export enum RouterModes {
    None = 0,
    Loading = 1,
    Anonymous = 2,
    User = 3,
    Admin = 10,
}

export class RouterViewModel {
    constructor() {
        makeObservable(this, {
            mode: computed,
        });
    }

    public get isLoggedIn() { return AppController.Instance.Auth.isLoggedIn; }
    public get isInitializing() { return AppController.Instance.isInitializing; }
    public get isPasswordResetMode() { return AppController.Instance.Auth.isPasswordResetMode; }
    public get isAdmin() { return AppViewModel.Instance.userRole.isAdmin; }

    public get mode(): RouterModes {
        if (this.isInitializing || AppController.Instance.Users.isInitializing) {
            return RouterModes.Loading;
        }

        if (!this.isLoggedIn) {
            return RouterModes.Anonymous;
        }

        if (this.isAdmin) {
            return RouterModes.Admin;
        }

        return RouterModes.User;
    }
}
